export const OPERATION_MONITORING_CONSTANTS = {
    'IMPORT_MONITORING_URL': 'import',
    'QUERIES_MONITORING_URL': 'monitor/queries',
    'BACKUP_AND_RESTORE_MONITORING_URL': 'monitor/backup-and-restore',
    'CLUSTER_MONITORING_URL': 'cluster'
};
